import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import "./App.scss";
import Header from "./component/shared/Header";
import Footer from "./component/shared/Footer/Footer";
import LandingPage from "./component/common/landingPage/LandingPage";
import PricingPage from "./component/common/PricingPage/PricingPage";
import FeaturedPlaylists from "./component/common/FeaturedPlaylists/FeaturedPlaylists";
import MusicStreaming from "./component/common/MusicStreaming/MusicStreaming";
import About from "./component/common/About/About";
import LegalDocuments from "./component/common/LegalDocuments/LegalDocuments";
import MusicMarketing from "./component/common/MusicMarketing/MusicMarketing";
import LegalForms from "./component/common/LegalForms/LegalForms";
import SellYourMusic from "./component/common/SellYourMusic/SellYourMusic";
import NotFound from "./component/NotFound";
import AdsPage from "./component/common/AdsPage/AdsPage";
import PlanCheckout from "./component/common/AdsPage/PlanCheckout";
import B2BPage from "./component/common/AdsPage/B2BPage";

// 🔥 Layout Component
function Layout({ handleScrollToSection }) {
  const location = useLocation();

  // FMDO ads funnel routes own the full viewport: no site header/footer/padding.
  const isFunnelRoute =
    location.pathname === "/ads" ||
    location.pathname.startsWith("/ads/") ||
    location.pathname === "/b2b";
  const hideLayout = isFunnelRoute;

  return (
    <>
      {/* Header */}
      {!hideLayout && (
        <header className="landing-header">
          <Header handleScrollToSection={handleScrollToSection} />
        </header>
      )}

      {/* Routes — `site-scope` opts a route into the global responsive
          base layer. The FMDO funnel pages are deliberately excluded. */}
      <div className={`main-content${isFunnelRoute ? " fmdo-full" : " site-scope"}`}>

        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/pricing/:id" element={<PricingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/services/featured-playlists" element={<FeaturedPlaylists />} />
          <Route path="/See-All-Platforms" element={<MusicStreaming />} />
          <Route path="/services/music-marketing" element={<MusicMarketing />} />
          <Route path="/support/legal-documents" element={<LegalDocuments />} />
          <Route path="/support/legal-forms/:id?" element={<LegalForms />} />
          <Route path="/sell-your-music" element={<SellYourMusic />} />
          <Route path="/ads" element={<AdsPage />} />
          <Route path="/ads/plan/:plan" element={<PlanCheckout />} />
          <Route path="/b2b" element={<B2BPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>

      {/* Footer */}
      {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    setIsScrolled(window.scrollY > 0);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const yOffset = -72;
      const y =
        section.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <div className="App">
      <Router>
        <Layout handleScrollToSection={handleScrollToSection} />
      </Router>
    </div>
  );
}

export default App;
